import { AxiosRequestConfig, AxiosResponse } from 'axios';
import { EHttpMethod } from './enums';
import fetchClient from './privateAxios';

import { preloadCommonModules } from './moduleLoader';
import { providerSearchPreloadModules } from './providerSearchPreloadModules';
import { preloadPEMModules } from './modulePEMLoader';
import { preloadSurestModules } from './moduleSurestLoader';
import { preloadVBCModules } from './moduleVBCLoader';
import { preloadPNBModules } from './modulePNBLoader';
import { pcorPreloadModules } from './pcorPreloadModules';
import { preloadFaq } from './faqloader';
import {preloadPaymentIntegrityModules} from './modulePaymentIntegrity'

class HttpService {
  private axiosPrivate = fetchClient();
  private readonly RETRY_STATUS_CODES = [504];
  private readonly MAX_RETRY_ATTEMPTS = 1;

  constructor() {
    // providerSearchPreloadModules();
    // preloadPEMModules();
    // preloadCommonModules();
    // preloadSurestModules();
    // preloadVBCModules();
    // preloadPNBModules();
    // pcorPreloadModules();
    // preloadPaymentIntegrityModules();
    // preloadFaq();
    this.setupInterceptors();
  }

  private setupInterceptors() {
     // Response interceptor for server-error retry
    this.axiosPrivate.interceptors.response.use(
      (response) => response,
      async (error) => {
        const status = error?.response?.status;
        const originalRequest = error?.config;

        if (!originalRequest || !this.RETRY_STATUS_CODES.includes(status)) {
          return Promise.reject(error);
        }

        originalRequest.__retryCount = (originalRequest.__retryCount || 0) + 1;
        if (originalRequest.__retryCount > this.MAX_RETRY_ATTEMPTS) {
          return Promise.reject(error);
        }
        return this.axiosPrivate(originalRequest);
      }
    );
  }

  private normalizeError(error: any) {
    return Promise.reject(error);
  }

  private async request<T>(
    method: EHttpMethod,
    url: string,
    options: AxiosRequestConfig
  ): Promise<T> {
    try {
      const response: AxiosResponse<T> = await this.axiosPrivate.request<T>({
        method,
        url,
        ...options,
      });
      return response.data;
    } catch (error) {
      return this.normalizeError(error);
    }
  }

  public async push<T, P>(
    url: string,
    payload: P,
    params?: any,
    hasAttachment = false
  ): Promise<T> {
    return this.request<T>(EHttpMethod.POST, url, {
      params,
      data: payload,
    });
  }

  public async get<T>(
    url: string,
    options: AxiosRequestConfig = {},
    hasAttachment = false
  ): Promise<T> {
    return this.request<T>(EHttpMethod.GET, url, options);
  }

  public async update<T, P>(
    url: string,
    payload: P,
    params?: any,
    hasAttachment = false
  ): Promise<T> {
    return this.request<T>(EHttpMethod.PUT, url, {
      params,
      data: payload,
    });
  }

  public async remove<T>(
    url: string,
    params?: any,
    data?: any,
    hasAttachment = false
  ): Promise<T> {
    return this.request<T>(EHttpMethod.DELETE, url, {
      params,
      data,
    });
  }
  setBaseURL(url: string) {
    this.axiosPrivate.defaults.baseURL = url;
  }
}

export { HttpService as default };
